export default "__VITE_ASSET__CLCZ9xv9__"